import microApp, { getActiveApps } from '@micro-zoe/micro-app'
import config from './appsConfig'
microApp.start({
  fetch(url, options) {
    // 修改在app运行时请求静态资源的fetch方法拦截
    if (url.startsWith('file:///')) {
      return fetchLocal(url)
    }
    return window.fetch(url, Object.assign(options)).then((res) => {
      return res.text()
    })
  },
  preFetchApps: Object.values(config), // 预加载应用
  plugins: {
    modules: {
      ngApp: [
        {
          loader(code, url) {
            // 因为js沙箱开启的原因，ngApp应用中nc.js中jsop对应的回调函数无法挂载到window上，所以修改成优先挂载window.rawWindow，以免jsonp请求成功后无法执行回调函数
            // 需要改写的js资源的完整路径 https://g.alicdn.com/AWSC/nc/1.88.0/nc.js，该路径是由 cdn.qinsilk.com/res/lib/awsc/awsc.js返回的js动态创建script生成
            if (url.includes('g.alicdn.com') && url.includes('/nc.js')) {
              if (code.includes('b=window')) {
                code = code.replace('b=window', 'b=window.rawWindow || window')
              }
            }
            return code
          },
        },
      ],
    },
  },
})
/**
 *
 * @param {Object} obj path: 路径, query: 传参
 */
function goMicroApp(obj) {
  if (!obj.path.startsWith('#')) obj.path = '#' + obj.path

  if (obj.query) {
    const searchParams = new URLSearchParams(obj.query)
    const queryStr = searchParams.toString()
    if (queryStr) obj.path = obj.path + '?' + queryStr
  }
  location.href = obj.path
  // window.history.pushState(history.state, '', obj.path)
  // // 主动触发路由更新
  // window.dispatchEvent(new PopStateEvent('popstate', { state: history.state }))
}

function fetchLocal(url) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest()
    xhr.onload = function () {
      resolve(xhr.response)
    }
    xhr.onerror = function (err) {
      reject(new TypeError('Local request failed:' + JSON.stringify(err)))
    }
    xhr.open('GET', url)
    xhr.send(null)
  })
}

function createRouterParams() {
  var routerParams = {}
  return {
    add: function (obj) {
      routerParams[obj.name] = {
        name: obj.name,
        params: obj.params,
        query: obj.query,
      }
    },
    get: function (key) {
      return routerParams[key]
    },
    del: function (key) {
      delete routerParams[key]
    },
  }
}
microApp.setGlobalData({
  goMicroApp,
  appConfig: config,
  getActiveApps,
  globalRouterParams: createRouterParams(),
}) // 设置全局数据
